import {
  Box,
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";

import { InvoiceRowDuplicates } from "../InvoiceRowDuplicates";
import {
  Container,
  Content,
  HeaderTable,
  StyledGrid,
  StyledGridContainer,
  TransactionsNotFoundWarn,
} from "../styles";

interface InvoiceDuplicateListProps {
  duplicates: any[];
  limitPerInvoice?: number;
  selected: any[];
  setSelected: React.Dispatch<React.SetStateAction<any[]>>;
}

export const InvoiceDuplicateList = ({ duplicates, limitPerInvoice, selected, setSelected }: InvoiceDuplicateListProps) => {
  const emptyRows = Math.max(0, 12 - (duplicates?.length || 0));

  return (
    <Box sx={{ overflow: 'auto', width: '100%', height: '630px' }}>
      <StyledGridContainer container sx={{ minWidth: '700px' }}>
        <Content>
          <StyledGrid item xs={12}>
            <Container>
              <TableContainer component={Paper}>
                <Table aria-label="tabela de duplicatas">
                  <HeaderTable>
                    <TableRow>
                      <TableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          checked={Array.isArray(selected) && duplicates.length > 0 && selected.length === duplicates.length}
                          indeterminate={Array.isArray(selected) && selected.length > 0 && selected.length < duplicates.length}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelected([...duplicates]);
                            } else {
                              setSelected([]);
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell>VALOR</TableCell>
                      <TableCell>VALOR LIBERADO</TableCell>
                      <TableCell>VALOR TAXA</TableCell>
                      <TableCell>VALOR A RECEBER</TableCell>
                      <TableCell>VENCIMENTO</TableCell>
                    </TableRow>
                  </HeaderTable>
                  <TableBody>
                    {duplicates?.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={8}>
                          <TransactionsNotFoundWarn>
                            Nenhuma transação encontrada!
                          </TransactionsNotFoundWarn>
                        </TableCell>
                      </TableRow>
                    ) : (
                      duplicates?.map((duplicate, index) => (
                        <InvoiceRowDuplicates
                          key={index}
                          duplicate={duplicate}
                          limitPerInvoice={limitPerInvoice}
                          checked={selected.some((item) => item.anticipationDuplicateId === duplicate.anticipationDuplicateId)}
                          onChange={(checked) => {
                            if (checked) {
                              setSelected((prev) => [...prev, duplicate]);
                            } else {
                              setSelected((prev) =>
                                prev.filter((d) => d.anticipationDuplicateId !== duplicate.anticipationDuplicateId)
                              );
                            }
                          }}
                        />
                      ))
                    )}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Container>
          </StyledGrid>
        </Content>
      </StyledGridContainer>
    </Box>
  );
};
